import { HttpClient } from '@angular/common/http';
import { ApiConfig } from './config/api.config';
import { SessionService } from './session.service';
import { asesorContrato } from '../models/asesorContrato';
import { Injectable } from '@angular/core';
import { novedadAsesor } from '../models/novedadAsesor';
import { ServiceClientUserAnswers } from '../models/service-client-user-answers.model';
import { Observable } from 'rxjs';
import { ServiceClientQuestions } from '../models/service-client-questions.model';

@Injectable()
export class serviceClientService{

    constructor(
        private http: HttpClient,
        private api: ApiConfig,
        private _sessionService: SessionService    
    ){}

    getInfoAsesor(){
        return this.http.get<asesorContrato>(this.api.url + '/serviceClient/'+this._sessionService.getSelectContract());
    }

    postEnviaNovedad(novedad : novedadAsesor){
        return this.http.post<any>(this.api.url + '/serviceClient/', novedad);
    }

    postRadicacionNovedad(cuerpo: novedadAsesor, numRadicado: number){
        return this.http.post<any>(this.api.url + '/serviceClient/mailNovedad/'+numRadicado, cuerpo);
    }

    getQuestions(idSolicitante: string, idSolicitado: string) : Observable<ServiceClientQuestions[]>{
        return this.http.get<ServiceClientQuestions[]>(this.api.url + '/serviceClient/Questions/' + idSolicitante + "/" + idSolicitado);
    }

    validateAnswers(solicitante: string, solicitado: string, respuestas: ServiceClientUserAnswers[]) : Observable<boolean>{
        return this.http.post<boolean>(this.api.url + '/serviceClient/valid/' + solicitante + "/" + solicitado, respuestas);
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/serviceClient.service.ts